import { IdentityRefFragment, UserFragment } from '@spotify/confidence-graphql';

export const identityNameFromUser = (userName: string): string => {
  return userName.replace('users/', 'identities/u');
};

export const identityRefFromUser = (
  user: UserFragment,
): IdentityRefFragment => ({
  __typename: 'IamV1Identity',
  name: identityNameFromUser(user.name),
  displayName: user.fullName,
  pictureUri: user.pictureUri,
});
